import store from '@/app/app-state';
import api from '@/api';

const getCountryValue = () =>
  store.getters['jobSearch/filters']?.country?.value ||
  store.getters['country/currentCountry'].value;

// eslint-disable-next-line import/prefer-default-export
export const keywordRecommendationRequest = (keyword, cancelSource = null) =>
  api
    .get(
      `/api/v1/search/keyword-recommendation/${store.getters.locale}/${encodeURIComponent(
        keyword,
      )}/${getCountryValue()}`,
      { cancelToken: cancelSource?.token },
    )
    .then(({ data }) => data?.payload?.content || []);
